<script>

import Loader from "@/components/Loader.vue";

export default {
    components: {Loader},
    data() {
        return {
            company_id: this.$route.params.id ? this.$route.params.id : this.$auth.user.company_id,
            settlement_id: this.$route.params.settlementId,
            settlement: null,
            loading: true,
        }
    },
    mounted() {
        axios.get('/companies/withdrawal-settlements/' + this.settlement_id)
            .then((data) => {
                this.settlement = data.data.data;
            }).finally(() => {
            this.loading = false;
        })
    }
}

</script>
<template>
    <section>
        <loader :loading="loading"/>
        <div v-if="!loading" class="mb-5 mt-5">
            <div class="is-size-4">
                {{ settlement.name }}
            </div>
            <p class="is-size-6">{{ $t('withdrawal_settlements.fields.amount.name') }}: {{ settlement.amount }}</p>
            <p class="is-size-6">{{ $t('withdrawal_settlements.fields.status.name') }}: {{ $t('withdrawal_settlements.fields.status.options.' + settlement.status) }}</p>
        </div>

        <withdrawal-requests-table :company-id="company_id" :settlement-id="settlement_id"/>
    </section>
</template>
